import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';

@Component({
  selector: 'app-search-exam-sub',
  templateUrl: './search-exam-sub.component.html',
  styleUrls: ['./search-exam-sub.component.scss']
})
export class SearchExamSubComponent implements OnInit {
  APIService: string;
  subGrid: any;

  constructor(
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,   public router: Router,  private httpClient: HttpClient,
   private spinner: NgxSpinnerService,
   private dialogRef2:MatDialogRef<SearchExamSubComponent>,
   private dialog: MatDialog,
     ) { this.APIService = environment.serviceUrl; }

  ngOnInit(): void {
    this.SubData(this.data)
  }

  SubData(data){

    this.subGrid = []
    this.spinner.show();
    const payload = {};
    payload['FsEfId'] = data.EfId
    this.umsService.SearchExamSub(payload).subscribe((res) => {
      this.spinner.hide();
      this.subGrid = res.data;
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.subGrid = []
    })
  }

}
